export default __webpack_public_path__ + "static/media/Will_Metivier.5ef2fb60.pdf";